import { combineEpics } from  'redux-observable';
import { getMessages } from './getMessages';
import { addMessage } from './addMessage';
import { deleteMessage } from './deleteMessage';
import { searchMessage } from './searchMessage';
import { editMessage } from './editMessage';
import { copyMessage } from './copyMessage';
import { sortMessages, categorySortMessages } from './sortMessages';
import { authRequest, authPopupClose, logoutRequest, loginWithToken, 
  loginWithQueryString } from './auth';
export default combineEpics(getMessages, addMessage, 
                            deleteMessage, searchMessage, 
                            authRequest, authPopupClose, 
                            logoutRequest, editMessage,
                            copyMessage, sortMessages,
                            categorySortMessages,
                            loginWithToken, loginWithQueryString,
                            );



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/epics/index.ts